.weekday {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: var(--rc-calendar-spacing-xxs) var(--rc-calendar-spacing-xs);
  border-right: var(--rc-calendar-border-base);
  color: var(--rc-calendar-color-text-secondary);
  font-size: var(--rc-calendar-font-size-text-sm);
  font-weight: var(--rc-calendar-font-weight-bold);
  text-overflow: ellipsis;
  white-space: nowrap;

  &:last-child {
    border-right: 0;
  }
}

.day {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: var(--rc-calendar-spacing-xxxs);
  border-right: var(--rc-calendar-border-base);
  border-bottom: var(--rc-calendar-border-base);
  background-color: var(--rc-calendar-color-surface-default);

  &:nth-child(7n) {
    border-right: 0;
  }

  &:nth-last-child(-n + 7) {
    border-bottom: 0;
  }
}

.day-number {
  --width: 24px;
  --height: 24px;
  --rc-calendar-line-height: 24px;

  width: var(--width);
  height: var(--height);
  margin-bottom: var(--rc-calendar-spacing-xxxs);
  color: var(--rc-calendar-color-text-heading);
  font-size: var(--rc-calendar-font-size-text-sm);
  line-height: var(--rc-calendar-line-height);
  text-align: center;
}

.day-outside .day-number {
  color: var(--rc-calendar-color-text-secondary);
}

.day-today .day-number {
  border-radius: 50%;
  background-color: var(--rc-calendar-color-primary-default);
  color: var(--rc-calendar-color-surface-default);
}

.day-body {
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  pointer-events: none;
  gap: 2px;
}

.slot {
  position: absolute;
  pointer-events: auto;
  inset: 0;
}

.slot-dropdown .slot-dropdown-menu {
  min-width: var(--rc-calendar-slot-dropdown-menu-min-width);
}

.day-events {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  gap: 2px;
}

.slot-indicator {
  height: var(--rc-calendar-minimum-event-height);
  min-height: var(--rc-calendar-minimum-event-height);
  background-color: var(--rc-calendar-color-primary-default);
}

.day-event {
  min-width: 0;
  pointer-events: auto;
}

.more {
  margin: 1px 1px 0;
  border: 0;
  background: none;
  color: var(--rc-calendar-color-text-default);
  font-size: var(--rc-calendar-font-size-text-base);
  text-align: start;
  cursor: pointer;
  pointer-events: auto;

  &:disabled {
    cursor: default;
  }
}
